export default __webpack_public_path__ + "static/media/icon_close.0c82fb42.svg";